































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { VForm, Chart } from '@/@types';
import { notEmptyRules } from '@/@utils';

@Component
export default class DialogChart extends Vue {
  /* ------------------------------------
  => Props declaration
  ------------------------------------ */
  @Prop({ required: true, type: Boolean })
  readonly dialog!: boolean;

  @Prop({ required: true, type: Object })
  readonly chart!: Chart;

  @Prop({
    required: false,
    type: Function,
    default() {
      return true;
    }
  })
  readonly closeDialog!: FunctionConstructor;

  /* ------------------------------------
  => Local State Declaration
  ------------------------------------ */
  valid: boolean = true;
  label: string = '';
  value: number = 0;
  color: string = '';

  /* ------------------------------------
  => Setter and Getter
  ** (Adopt store variables to local state)
  ------------------------------------ */
  get isLoading(): boolean {
    return this.$store.state.chart.isLoading;
  }

  /* ------------------------------------
  => Methods
  ------------------------------------ */
  editChart(): void {
    const editChartForm = this.$refs.editChartForm as VForm;
    if (editChartForm.validate()) {
      const data: Chart = {
        id: this.chart.id,
        label: this.label,
        value: this.value,
        color: this.color
      };
      this.$store.dispatch('chart/updateChartData', data).then(() => {
        this.closeDialog();
      });
    }
  }

  notEmpty(identifier: string): any[] {
    return notEmptyRules(identifier);
  }

  /* ------------------------------------
  => Watcher
  ------------------------------------ */
  @Watch('dialog')
  async handleOnLoad(newValue: boolean): Promise<void> {
    if (newValue) {
      this.label = this.chart.label;
      this.value = this.chart.value;
      this.color = this.chart.color || 'black';
    }
  }
}
